var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "215.07 391.74 36.34 391.74 59.51 334.77 71.75 328.06 91.02 283.51 106.6 274.36 121.42 247.56 136.04 247.56 168.54 302.43 185.08 310.97 215.07 391.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.34 391.74 113.43 391.74 113.43 347.28 133.21 316.16 123.79 283.51 136.04 247.56 121.42 247.56 106.6 274.36 91.02 283.51 71.75 328.06 59.51 334.77 36.34 391.74",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.04 391.74 143.51 368.33 155.59 356.43 160.99 342.4 164.75 345.45 164.75 358.87 155.59 369.55 155.59 391.82 136.04 391.74",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.4 319.65 152.4 310.26 157.79 304.87 160.31 308.07 156.95 312.26 158.46 321.19 150.4 319.65",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.21 391.69 463.66 391.69 414.33 288.67 390.6 278.49 365.41 229.27 348.8 211.41 334.16 178.82 317.02 181.6 287.71 249.88 271.34 262.09 244.76 332.42 218.58 357.85 202.21 391.69",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.16 178.82 336.17 230.16 316.87 257.13 325.92 277.76 308 323.26 323.62 360.9 314.37 391.69 202.21 391.69 218.58 357.85 244.76 332.42 271.34 262.09 287.71 249.88 317.02 181.6 334.16 178.82",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.34 310.03 342.8 286.63 341.74 276.71 346.76 269.59 352.83 289.81 334.62 310.03 329.34 310.03",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.78 138.02 319.73 139.96 321.87 140.27 320.32 141.77 320.69 143.9 318.78 142.9 316.87 143.9 317.23 141.77 315.69 140.27 317.82 139.96 318.78 138.02",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.27 234.81 140.23 236.74 142.36 237.05 140.82 238.56 141.18 240.69 139.27 239.68 137.36 240.69 137.72 238.56 136.18 237.05 138.31 236.74 139.27 234.81",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.67 67.08 389.63 69.01 391.76 69.32 390.22 70.83 390.58 72.95 388.67 71.95 386.76 72.95 387.13 70.83 385.58 69.32 387.72 69.01 388.67 67.08",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.18 70.02 175.14 71.95 177.27 72.26 175.73 73.77 176.09 75.89 174.18 74.89 172.27 75.89 172.64 73.77 171.09 72.26 173.23 71.95 174.18 70.02",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.15 228.93 447.11 230.86 449.25 231.17 447.7 232.68 448.06 234.81 446.15 233.8 444.24 234.81 444.61 232.68 443.06 231.17 445.2 230.86 446.15 228.93",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.71 134.69 236.66 136.63 238.8 136.94 237.25 138.44 237.62 140.57 235.71 139.57 233.79 140.57 234.16 138.44 232.61 136.94 234.75 136.63 235.71 134.69",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.44 94.84 46.39 96.77 48.52 97.08 46.98 98.59 47.34 100.72 45.44 99.71 43.52 100.72 43.89 98.59 42.34 97.08 44.48 96.77 45.44 94.84",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.65 210.39 87.6 212.32 89.74 212.63 88.19 214.14 88.56 216.27 86.65 215.26 84.74 216.27 85.1 214.14 83.56 212.63 85.69 212.32 86.65 210.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.44 243.33 46.02 244.53 47.34 244.72 46.39 245.65 46.62 246.97 45.44 246.34 44.25 246.97 44.48 245.65 43.52 244.72 44.84 244.53 45.44 243.33",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.72 121.92 180.31 123.12 181.63 123.31 180.68 124.24 180.91 125.56 179.72 124.94 178.54 125.56 178.77 124.24 177.81 123.31 179.13 123.12 179.72 121.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.94 228.23 279.53 229.43 280.85 229.62 279.9 230.55 280.12 231.87 278.94 231.25 277.76 231.87 277.99 230.55 277.03 229.62 278.35 229.43 278.94 228.23",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.8 105.2 56.4 106.4 57.72 106.59 56.76 107.52 56.99 108.84 55.8 108.22 54.62 108.84 54.85 107.52 53.9 106.59 55.22 106.4 55.8 105.2",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.76 211.51 392.35 212.71 393.67 212.9 392.72 213.83 392.94 215.15 391.76 214.53 390.58 215.15 390.81 213.83 389.85 212.9 391.17 212.71 391.76 211.51",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.62 267.77 95.21 268.97 96.53 269.16 95.58 270.09 95.8 271.41 94.62 270.79 93.44 271.41 93.67 270.09 92.71 269.16 94.03 268.97 94.62 267.77",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.7 203.94 72.29 205.13 73.61 205.33 72.66 206.26 72.88 207.57 71.7 206.95 70.52 207.57 70.75 206.26 69.79 205.33 71.11 205.13 71.7 203.94",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.48 112.66 266.07 113.85 267.39 114.04 266.43 114.97 266.66 116.29 265.48 115.67 264.3 116.29 264.52 114.97 263.56 114.04 264.88 113.85 265.48 112.66",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.44 267.77 397.03 268.97 398.35 269.16 397.39 270.09 397.62 271.41 396.44 270.79 395.26 271.41 395.49 270.09 394.53 269.16 395.85 268.97 396.44 267.77",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.75 153.62 456.34 154.82 457.66 155.01 456.7 155.94 456.93 157.26 455.75 156.64 454.57 157.26 454.79 155.94 453.84 155.01 455.16 154.82 455.75 153.62",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.62 151.81 404.21 153 405.53 153.19 404.57 154.13 404.8 155.44 403.62 154.82 402.44 155.44 402.66 154.13 401.71 153.19 403.03 153 403.62 151.81",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.35,99.4a26.34,26.34,0,1,1-28.7-38.78,24.64,24.64,0,1,0,28.7,38.78Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.15 391.73 89.61 391.48 143.07 391.4 250 391.23 356.93 391.39 410.39 391.48 463.85 391.73 410.39 391.97 356.93 392.06 250 392.23 143.07 392.06 89.61 391.97 36.15 391.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.37,400.69H30.63a4.48,4.48,0,0,1-4.48-4.48h0a4.47,4.47,0,0,1,4.48-4.48H469.37a4.48,4.48,0,0,1,4.48,4.48h0A4.49,4.49,0,0,1,469.37,400.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.1,
    y: 409.55,
    width: 285.53,
    height: 8.96,
    rx: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.31,436.23H153.82a4.47,4.47,0,0,1-4.48-4.48h0a4.48,4.48,0,0,1,4.48-4.48H355.31a4.48,4.48,0,0,1,4.48,4.48h0A4.47,4.47,0,0,1,355.31,436.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.38,
    y: 409.55,
    width: 30.01,
    height: 8.96,
    rx: 4.48,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.13,436.23H379.6a4.48,4.48,0,0,1-4.48-4.48h0a4.49,4.49,0,0,1,4.48-4.48h10.53a4.49,4.49,0,0,1,4.48,4.48h0A4.48,4.48,0,0,1,390.13,436.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.48,409.64H117.59a4.48,4.48,0,1,0,0-9H233.48a4.48,4.48,0,0,0,0,9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.83,409.64h-76a4.48,4.48,0,1,0,0-9h76a4.48,4.48,0,0,0,0,9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.34,427.37H179.73a4.48,4.48,0,0,0,0-9H296.34a4.48,4.48,0,1,0,0,9Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mountains--inject-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "66.13 391.65 345.14 391.65 294.21 266.09 269.71 253.69 243.71 193.71 226.55 171.94 211.44 132.22 193.74 135.61 163.48 218.82 146.59 233.7 110.06 319.41 83.03 350.4 66.13 391.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.44 132.22 213.51 194.79 193.59 227.65 202.93 252.8 184.43 308.25 200.56 354.13 191.01 391.65 66.13 391.65 83.03 350.4 110.06 319.41 146.59 233.7 163.48 218.82 193.74 135.61 211.44 132.22",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.46 292.13 220.36 263.61 219.27 251.52 224.45 242.84 230.72 267.49 211.91 292.13 206.46 292.13",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.87 391.67 227.28 391.67 254.56 324.64 273.85 309.17 293.74 251.45 309.83 239.59 325.12 204.87 340.22 204.87 373.77 275.96 390.85 287.03 433.87 391.67",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.28 391.67 316.88 391.67 316.88 334.07 337.3 293.75 327.57 251.45 340.22 204.87 325.12 204.87 309.83 239.59 293.74 251.45 273.85 309.17 254.56 324.64 227.28 391.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.22 391.67 347.93 361.35 360.41 345.93 365.97 327.75 369.86 331.7 369.86 349.09 360.41 362.93 360.41 391.78 340.22 391.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.04 298.27 357.11 286.1 362.67 279.12 365.28 283.27 361.8 288.69 363.37 300.27 355.04 298.27",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tent--inject-52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.75,
    y: 387.66,
    width: 1.48,
    height: 4.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.14,
    y: 387.66,
    width: 1.48,
    height: 4.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.14 391.82 290.04 360.75 311.49 391.82 269.14 391.82",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.14 391.82 290.04 360.75 311.49 391.82 269.14 391.82",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.04 360.75 320.68 360.75 341.97 391.82 311.49 391.82 290.04 360.75",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.1 366.4 317.1 366.4 321.36 372.62 307.39 372.62 303.1 366.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.17 391.82 296.35 391.82 290.04 360.75 283.17 391.82",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.74,
    y: 387.66,
    width: 1.48,
    height: 4.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,360.75c-5.06,10.09-10.93,21.19-16.41,31.07,5.07-10.1,10.92-21.2,16.41-31.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,360.75c5.43,9.82,11.22,20.86,16.24,30.9-5.43-9.83-11.23-20.86-16.24-30.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.17,391.82a16.72,16.72,0,0,0-5.5-8.28L290,360.75Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.35,391.82,290,360.75l12.88,24A8,8,0,0,0,296.35,391.82Z",
    style: {
      fill: "#F0934E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.68,391.42c-1.14,1.15-14.5,1.66-19.36,1.66S41.1,392.57,40,391.42s15-90,19.37-90S79.83,390.27,78.68,391.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,368.79c-3.3,1.26-15.53,6.24-18.17,7.69,0-.56,0-1.11,0-1.67,2.95-1.74,5.92-3.45,8.87-5.18A101.68,101.68,0,0,0,79.19,364c.14-.11.06-.4-.14-.32a78.58,78.58,0,0,0-9.33,5.16c-3,1.76-6,3.58-8.95,5.41q0-6.39-.05-12.77a101.93,101.93,0,0,0,13.94-7.08c.15-.09,0-.37-.13-.3a101.8,101.8,0,0,0-13.82,6.81c0-2.21,0-4.43,0-6.64-.13-11.4-.15-22.8-.44-34.2,2.9-1.46,5.89-2.75,8.79-4.22.19-.1,0-.43-.15-.35-2.94,1.14-5.77,2.51-8.66,3.77-.16-5.88-.38-11.75-.74-17.63a.15.15,0,0,0-.3,0c-.41,10.92-.38,21.85-.24,32.78-3-2.4-6.21-4.52-9.26-6.85-.12-.09-.24.11-.12.2,3.2,2.43,6.19,5.13,9.39,7.55l0,1.85c-3.26-1.49-6.57-2.87-9.86-4.28-.26-.11-.49.26-.22.38,3.35,1.61,6.69,3.25,10.09,4.77.07,5.41.17,10.82.24,16.23.12,9.45.33,18.9.53,28.35q-9.22-4.66-18.58-9.08c-.24-.11-.45.22-.21.36a194.18,194.18,0,0,0,18.8,9.44c.17,7.85.33.71.43,8.56a.38.38,0,0,0,.75,0c-.11-10-.13-5-.16-15,3.24-.8,15.49-6.05,18.4-7.49C79.48,369.19,79.27,368.67,79,368.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.67,391.35c-1,1-12.45,1.42-16.62,1.42s-15.64-.44-16.62-1.42,12.9-77.2,16.62-77.2S179.65,390.36,178.67,391.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.9,371.93c-2.83,1.08-13.33,5.35-15.59,6.6,0-.48,0-1,0-1.44,2.53-1.49,5.07-3,7.61-4.44a87.44,87.44,0,0,0,8.19-4.87c.13-.09.06-.34-.11-.27a67.38,67.38,0,0,0-8,4.43c-2.58,1.51-5.13,3.07-7.67,4.64,0-3.65,0-7.31-.05-11a86.67,86.67,0,0,0,12-6.08c.13-.07,0-.32-.11-.25a88,88,0,0,0-11.85,5.84c0-1.9,0-3.8,0-5.7-.11-9.78-.13-19.57-.38-29.35,2.49-1.25,5.06-2.36,7.54-3.62.17-.08,0-.37-.12-.3-2.53,1-5,2.15-7.44,3.24-.13-5-.32-10.09-.63-15.13a.13.13,0,0,0-.26,0c-.35,9.37-.32,18.75-.2,28.12-2.58-2.05-5.33-3.87-7.95-5.87-.1-.08-.2.1-.1.17,2.74,2.09,5.31,4.4,8.06,6.48,0,.53,0,1.06,0,1.59-2.8-1.28-5.63-2.47-8.46-3.68-.22-.09-.42.23-.19.33,2.88,1.39,5.74,2.79,8.66,4.09.06,4.65.14,9.29.2,13.93.11,8.11.29,16.22.46,24.33q-7.92-4-15.94-7.79c-.21-.09-.39.19-.18.31a164.19,164.19,0,0,0,16.13,8.1c.15,6.74.29,1.65.37,8.39a.32.32,0,0,0,.64,0c-.1-8.59-.11-5.36-.13-13.95,2.78-.69,13.29-5.19,15.79-6.43C179.35,372.27,179.17,371.82,178.9,371.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.36,391.75c.83.83,10.48,1.2,14,1.2s13.17-.37,14-1.2-10.86-65-14-65S69.53,390.92,70.36,391.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.16,375.39c2.39.91,11.23,4.51,13.14,5.56v-1.2c-2.13-1.26-4.27-2.5-6.41-3.74a78.32,78.32,0,0,1-6.9-4.1c-.1-.08,0-.3.1-.24a58.38,58.38,0,0,1,6.75,3.73c2.17,1.28,4.32,2.59,6.46,3.91,0-3.07,0-6.15,0-9.22A75,75,0,0,1,73.27,365c-.11-.07,0-.27.09-.22a74,74,0,0,1,10,4.92c0-1.6,0-3.2,0-4.8.09-8.23.1-16.48.31-24.71-2.09-1.06-4.25-2-6.34-3.05-.14-.07,0-.31.1-.26,2.13.83,4.17,1.82,6.26,2.73q.17-6.37.53-12.74a.11.11,0,0,1,.22,0c.3,7.89.27,15.79.17,23.69,2.17-1.74,4.49-3.27,6.7-4.95.08-.07.17.08.08.14-2.31,1.76-4.47,3.71-6.78,5.46,0,.45,0,.89,0,1.34,2.35-1.08,4.74-2.08,7.12-3.1.19-.08.35.19.16.28-2.42,1.16-4.84,2.35-7.29,3.44-.06,3.91-.12,7.83-.17,11.73-.09,6.83-.24,13.66-.39,20.49,4.44-2.25,8.93-4.44,13.43-6.56.17-.08.32.16.15.26A138,138,0,0,1,84,385.88c-.12,5.68-.24,1.26-.31,6.94a.27.27,0,0,1-.53,0c.07-7.24.09-4.39.11-11.62A132.17,132.17,0,0,1,70,375.79C69.78,375.68,69.93,375.31,70.16,375.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.77,391.22c-1.06,1.06-13.39,1.53-17.87,1.53s-16.82-.47-17.88-1.53,13.88-83,17.88-83S425.83,390.16,424.77,391.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,370.33c-3,1.16-14.33,5.76-16.77,7.1,0-.51,0-1,0-1.54l8.19-4.78a95,95,0,0,0,8.81-5.23c.13-.1.06-.37-.13-.3a75.36,75.36,0,0,0-8.62,4.76c-2.77,1.63-5.51,3.31-8.25,5,0-3.93,0-7.86-.05-11.79A93.52,93.52,0,0,0,421.05,357c.14-.09.05-.35-.11-.28A94.22,94.22,0,0,0,408.19,363c0-2,0-4.08-.05-6.12-.11-10.52-.13-21-.4-31.57,2.68-1.35,5.44-2.54,8.11-3.89.17-.09,0-.4-.14-.33-2.71,1.06-5.32,2.32-8,3.49-.14-5.43-.35-10.85-.68-16.27a.14.14,0,0,0-.28,0c-.38,10.08-.34,20.16-.22,30.24-2.77-2.21-5.73-4.17-8.55-6.31-.11-.09-.21.1-.1.18,2.94,2.25,5.7,4.73,8.66,7,0,.57,0,1.14,0,1.71-3-1.37-6.05-2.65-9.09-3.95-.24-.11-.45.23-.21.35,3.1,1.48,6.18,3,9.32,4.4q.11,7.49.22,15c.11,8.72.3,17.44.49,26.16q-8.52-4.31-17.15-8.38c-.22-.1-.41.21-.19.33a180.28,180.28,0,0,0,17.35,8.72c.16,7.24.31,1.77.4,9a.34.34,0,0,0,.68,0c-.1-9.24-.11-5.77-.14-15,3-.74,14.3-5.58,17-6.9C425.51,370.7,425.31,370.22,425,370.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.77,391.22c-1.06,1.06-13.39,1.53-17.88,1.53s-16.81-.47-17.87-1.53,13.87-83,17.87-83S374.82,390.16,373.77,391.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,370.33c-3,1.16-14.33,5.76-16.77,7.1v-1.54q4.08-2.4,8.18-4.78a95,95,0,0,0,8.81-5.23c.13-.1.06-.37-.12-.3a74.52,74.52,0,0,0-8.62,4.76c-2.78,1.63-5.52,3.31-8.26,5,0-3.93,0-7.86-.05-11.79A94.21,94.21,0,0,0,370.05,357c.14-.09,0-.35-.12-.28A94.8,94.8,0,0,0,357.18,363q0-3.06,0-6.12c-.12-10.52-.14-21-.4-31.57,2.67-1.35,5.43-2.54,8.1-3.89.18-.09.06-.4-.13-.33-2.72,1.06-5.33,2.32-8,3.49-.15-5.43-.36-10.85-.69-16.27a.14.14,0,0,0-.28,0c-.37,10.08-.34,20.16-.21,30.24-2.78-2.21-5.73-4.17-8.55-6.31-.11-.09-.22.1-.11.18,2.95,2.25,5.71,4.73,8.67,7,0,.57,0,1.14,0,1.71-3-1.37-6.06-2.65-9.1-3.95-.23-.11-.45.23-.2.35,3.09,1.48,6.18,3,9.31,4.4.07,5,.16,10,.22,15,.11,8.72.31,17.44.49,26.16q-8.51-4.31-17.15-8.38c-.22-.1-.41.21-.19.33a180.45,180.45,0,0,0,17.36,8.72c.15,7.24.3,1.77.39,9a.35.35,0,0,0,.69,0c-.1-9.24-.12-5.77-.15-15,3-.74,14.3-5.58,17-6.9C374.5,370.7,374.31,370.22,374,370.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.19,392c.74.74,9.36,1.07,12.49,1.07s11.76-.33,12.5-1.07-9.7-58-12.5-58S366.45,391.27,367.19,392Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,377.41c2.13.81,10,4,11.72,5v-1.08c-1.9-1.12-3.81-2.22-5.72-3.33a69.18,69.18,0,0,1-6.15-3.66c-.1-.07,0-.26.08-.21a52.08,52.08,0,0,1,6,3.33c1.94,1.14,3.85,2.31,5.77,3.49,0-2.75,0-5.49,0-8.24a65.44,65.44,0,0,1-9-4.57c-.1-.05,0-.24.08-.19a66.33,66.33,0,0,1,8.91,4.39l0-4.28c.08-7.35.1-14.71.28-22.06-1.87-.94-3.79-1.77-5.66-2.72-.12-.06,0-.28.09-.23,1.9.74,3.73,1.62,5.59,2.44.1-3.79.24-7.58.48-11.37a.1.1,0,0,1,.19,0c.26,7,.24,14.09.15,21.14,1.94-1.55,4-2.92,6-4.42.07-.06.15.07.07.13-2.06,1.57-4,3.31-6.05,4.87,0,.4,0,.8,0,1.19,2.1-1,4.23-1.85,6.36-2.76.16-.07.31.17.14.25-2.16,1-4.32,2.09-6.51,3.07,0,3.49-.11,7-.15,10.47-.08,6.1-.21,12.19-.35,18.28,4-2,8-4,12-5.85.15-.07.29.15.13.23a122.54,122.54,0,0,1-12.12,6.09c-.11,5.07-.22,1-.28,6.08a.24.24,0,0,1-.48,0c.07-6.46.08-3.8.1-10.26a119.37,119.37,0,0,1-11.87-4.83C366.68,377.67,366.81,377.33,367,377.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.52,391.89c.74.74,9.36,1.07,12.5,1.07s11.75-.33,12.49-1.07-9.7-58-12.49-58S126.78,391.15,127.52,391.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.35,377.3c2.13.81,10,4,11.72,5,0-.36,0-.72,0-1.08l-5.72-3.34a65.71,65.71,0,0,1-6.16-3.66c-.09-.07,0-.26.09-.2a50.42,50.42,0,0,1,6,3.32c1.94,1.14,3.86,2.31,5.77,3.49,0-2.74,0-5.49,0-8.23a66.58,66.58,0,0,1-9-4.57c-.1-.06,0-.24.08-.19a66.33,66.33,0,0,1,8.91,4.39c0-1.43,0-2.86,0-4.28.07-7.35.09-14.71.28-22.06-1.87-1-3.8-1.78-5.67-2.73-.12-.06,0-.27.09-.22,1.9.74,3.73,1.62,5.59,2.44.1-3.8.25-7.59.48-11.37a.1.1,0,1,1,.19,0c.27,7,.24,14.08.16,21.13,1.93-1.55,4-2.91,6-4.41.08-.06.15.07.07.12-2.06,1.57-4,3.31-6.05,4.88,0,.39,0,.79,0,1.19,2.1-1,4.23-1.85,6.36-2.76.16-.08.31.16.14.24-2.16,1-4.32,2.1-6.51,3.08l-.15,10.47c-.08,6.09-.21,12.18-.34,18.28q5.94-3,12-5.85c.15-.08.29.14.14.23a128.42,128.42,0,0,1-12.13,6.09c-.11,5.06-.22,1.12-.28,6.19a.24.24,0,0,1-.48,0c.07-6.46.08-3.92.1-10.38a119.31,119.31,0,0,1-11.87-4.82C127,377.55,127.15,377.22,127.35,377.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.72,391.78c.74.74,9.36,1.07,12.49,1.07s11.76-.33,12.5-1.07-9.7-58-12.5-58S201,391,201.72,391.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.55,377.18c2.13.81,10,4,11.72,5v-1.08c-1.9-1.12-3.81-2.22-5.72-3.33s-4.24-2.26-6.15-3.66c-.1-.07,0-.26.08-.21a52.08,52.08,0,0,1,6,3.33c1.94,1.14,3.85,2.31,5.77,3.49,0-2.75,0-5.49,0-8.24a65.44,65.44,0,0,1-9-4.57c-.1-.06,0-.24.08-.19a66.33,66.33,0,0,1,8.91,4.39l0-4.28c.08-7.35.1-14.71.28-22.06-1.87-.94-3.79-1.77-5.66-2.72-.12-.06,0-.28.09-.23,1.9.74,3.73,1.62,5.59,2.44.1-3.79.25-7.58.48-11.37a.1.1,0,0,1,.19,0c.26,7,.24,14.09.15,21.14,1.94-1.55,4-2.92,6-4.42.08-.06.15.07.07.13-2.06,1.57-4,3.31-6,4.87,0,.4,0,.8,0,1.19,2.1-1,4.23-1.85,6.36-2.76.16-.07.31.17.14.25-2.16,1-4.32,2.09-6.51,3.07-.05,3.49-.11,7-.15,10.47-.08,6.1-.21,12.19-.34,18.28,4-2,8-4,12-5.85.15-.07.29.14.13.23a124.76,124.76,0,0,1-12.12,6.09c-.11,5.07-.22,1.24-.28,6.31a.24.24,0,0,1-.48,0c.07-6.46.08-4,.1-10.49a119.37,119.37,0,0,1-11.87-4.83C201.21,377.44,201.34,377.1,201.55,377.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.09,391.78c.74.74,9.36,1.07,12.49,1.07s11.75-.33,12.49-1.07-9.7-58-12.49-58S434.35,391,435.09,391.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.92,377.18c2.12.81,10,4,11.72,5v-1.08c-1.9-1.12-3.81-2.22-5.72-3.33a70.34,70.34,0,0,1-6.16-3.66c-.09-.07,0-.26.09-.21a51.14,51.14,0,0,1,6,3.33c1.94,1.14,3.86,2.31,5.77,3.49,0-2.75,0-5.49,0-8.24a64.32,64.32,0,0,1-9-4.57c-.1-.06,0-.24.08-.19a66.33,66.33,0,0,1,8.91,4.39c0-1.42,0-2.85,0-4.28.08-7.35.09-14.71.28-22.06-1.87-.94-3.8-1.77-5.67-2.72-.12-.06,0-.28.1-.23,1.9.74,3.72,1.62,5.58,2.44.11-3.79.25-7.58.48-11.37a.1.1,0,0,1,.2,0c.26,7,.24,14.09.15,21.14,1.94-1.55,4-2.92,6-4.42.08-.06.15.07.08.13-2.06,1.57-4,3.31-6.06,4.87,0,.4,0,.8,0,1.19,2.1-1,4.23-1.85,6.35-2.76.17-.07.32.17.15.25-2.17,1-4.32,2.09-6.51,3.07-.05,3.49-.11,7-.16,10.47-.07,6.1-.21,12.19-.34,18.28,4-2,8-4,12-5.85a.13.13,0,0,1,.13.23,124.92,124.92,0,0,1-12.13,6.09c-.11,5.07-.21,1.24-.28,6.31,0,.3-.48.3-.47,0,.07-6.46.08-4,.1-10.49a117.44,117.44,0,0,1-11.87-4.83C434.57,377.44,434.71,377.1,434.92,377.18Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.63,454.39h-1.95v3.44a.88.88,0,0,1-1.75,0v-9.34a.86.86,0,0,1,.87-.87h2.83a3.39,3.39,0,1,1,0,6.77Zm-1.95-1.75h1.95a1.63,1.63,0,1,0,0-3.26h-1.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.7,456.09h-3.85l-.78,2.05a.88.88,0,0,1-.82.56,1,1,0,0,1-.3-.05.89.89,0,0,1-.52-1.14l3.5-9.32a.87.87,0,0,1,.84-.55.85.85,0,0,1,.83.55l3.5,9.32a.87.87,0,0,1-.82,1.19.86.86,0,0,1-.81-.56Zm-.65-1.74-1.28-3.41-1.29,3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.27,453a5.85,5.85,0,0,1,9.45-4.48.9.9,0,1,1-1.11,1.42,4.12,4.12,0,0,0-2.5-.85,3.91,3.91,0,0,0-2.85,1.15,3.81,3.81,0,0,0-1.18,2.76,3.77,3.77,0,0,0,1.18,2.72,3.91,3.91,0,0,0,2.85,1.15,4.31,4.31,0,0,0,2.17-.6v-2.17H204a.92.92,0,0,1-.91-.9.89.89,0,0,1,.91-.88h3.15a.89.89,0,0,1,.91.88v3.5a2.19,2.19,0,0,1,0,.27.26.26,0,0,0,0,.08h0a.74.74,0,0,1-.31.38,5.84,5.84,0,0,1-9.43-4.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.64,457.83v-9.34a.86.86,0,0,1,.87-.87h5.18a.88.88,0,0,1,.87.87.89.89,0,0,1-.87.89H213.4v2.89h3.69a.88.88,0,0,1,0,1.76H213.4v2.91h4.29a.88.88,0,0,1,0,1.76h-5.13s0,0,0,0l0,0A.87.87,0,0,1,211.64,457.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.51,457.83a.86.86,0,1,1-1.72,0v-9.2h0a.84.84,0,0,1,.35-.73.87.87,0,0,1,1.2.19l5.11,7.07v-6.52a.86.86,0,0,1,.86-.85.87.87,0,0,1,.87.85v9.2a.88.88,0,0,1-.87.87.86.86,0,0,1-.65-.32s-.07-.06-.08-.09l-5.07-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.92,449a5.81,5.81,0,0,1,0,8,5.23,5.23,0,0,1-3.78,1.69,5.37,5.37,0,0,1-3.88-1.69,5.89,5.89,0,0,1,0-8,5.26,5.26,0,0,1,3.88-1.7A5.13,5.13,0,0,1,245.92,449Zm-.21,4a4.09,4.09,0,0,0-1.07-2.77,3.42,3.42,0,0,0-2.5-1.12,3.46,3.46,0,0,0-2.57,1.12A4,4,0,0,0,238.5,453a4,4,0,0,0,1.07,2.75,3.44,3.44,0,0,0,2.57,1.14,3.41,3.41,0,0,0,2.5-1.14A4,4,0,0,0,245.71,453Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.54,449.38H254v8.45a.87.87,0,0,1-1.74,0v-8.45h-2.5a.89.89,0,0,1-.87-.89.86.86,0,0,1,.87-.87h6.76a.87.87,0,0,1,.87.87A.9.9,0,0,1,256.54,449.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.76,457.83v-9.34a.87.87,0,0,1,.87-.87h5.18a.88.88,0,0,1,0,1.76h-4.29v2.89h3.69a.88.88,0,0,1,0,1.76h-3.69v3.8a.89.89,0,0,1-.89.87A.87.87,0,0,1,264.76,457.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,449a5.81,5.81,0,0,1,0,8A5.23,5.23,0,0,1,279,458.7,5.35,5.35,0,0,1,275.1,457a5.89,5.89,0,0,1,0-8,5.24,5.24,0,0,1,3.87-1.7A5.13,5.13,0,0,1,282.76,449Zm-.21,4a4.1,4.1,0,0,0-1.08-2.77,3.42,3.42,0,0,0-5.06,0,4,4,0,0,0-1.08,2.77,3.92,3.92,0,0,0,1.08,2.75,3.38,3.38,0,0,0,5.06,0A4,4,0,0,0,282.55,453Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.35,458.7a4.57,4.57,0,0,1-4.58-4.58v-5.63a.86.86,0,0,1,.87-.87.88.88,0,0,1,.89.87v5.63a2.82,2.82,0,1,0,5.64,0v-5.63a.88.88,0,0,1,1.75,0v5.63A4.58,4.58,0,0,1,291.35,458.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.14,457.83a.86.86,0,1,1-1.72,0v-9.2h0a.84.84,0,0,1,.35-.73.87.87,0,0,1,1.2.19l5.11,7.07v-6.52a.86.86,0,0,1,.86-.85.87.87,0,0,1,.87.85v9.2a.88.88,0,0,1-.87.87.84.84,0,0,1-.65-.32.22.22,0,0,1-.08-.09l-5.07-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.81,457.83v-9.34a.86.86,0,0,1,.87-.87h1.87a5.54,5.54,0,0,1,0,11.08h-1.87A.87.87,0,0,1,310.81,457.83Zm1.76-.89h1a3.78,3.78,0,0,0,0-7.56h-1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Number--inject-52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.06,173.3s0,0,0,0a9.81,9.81,0,0,0-.79-.79h0a9.57,9.57,0,0,0-.78-.78s0,0,0,0a8.41,8.41,0,0,0-.79-.79h0a8.41,8.41,0,0,0-.79-.79s0,0,0,0a9.57,9.57,0,0,0-.78-.78h0a9.81,9.81,0,0,0-.79-.79s0,0,0,0a9.57,9.57,0,0,0-.78-.78h0a9.81,9.81,0,0,0-.79-.79s0,0,0,0a9.57,9.57,0,0,0-.78-.78h0a11.41,11.41,0,0,0-2.79-2.24V85.29c0-.41-.21-.62-.21-1a2.24,2.24,0,0,0-.21-1.25c0-.21-.2-.63-.2-.84a8.57,8.57,0,0,0-.42-1.25,1.52,1.52,0,0,1-.42-.84,5.17,5.17,0,0,0-.84-1c-.21-.21-.41-.62-.62-.84l-.84-.83c0-.13-.16-.26-.34-.34l-.41-.42-.05,0c0-.13-.16-.25-.34-.34l-.41-.41,0,0c0-.13-.16-.26-.34-.34L161,75,161,75c0-.13-.16-.26-.34-.34l-.41-.41,0,0c0-.12-.16-.25-.34-.34l-.42-.41,0,0c0-.13-.16-.26-.34-.34l-.41-.42,0,0c0-.12-.16-.25-.34-.34l-.42-.41,0,0c0-.13-.16-.26-.34-.34L157,71,157,71c0-.13-.16-.25-.34-.34l-.41-.41,0,0c0-.13-.16-.26-.34-.34l-.46-.46c0-.2-.41-.41-.62-.41a.2.2,0,0,0-.2-.22c-.43-.2-.64-.41-1.06-.62-.21-.21-.62-.42-1-.84-.22,0-.63-.2-.84-.2-.42-.21-1-.21-1.25-.43a2,2,0,0,1-1.06-.2h-3.54a1.3,1.3,0,0,1-.84.2c-.62.22-1,.22-1.25.43-.41,0-.62.2-.84.62a2.27,2.27,0,0,0-1.25.42c-.2.21-.62.42-.84.62a2,2,0,0,1-1,.63,2.72,2.72,0,0,1-.62.84c-.21.21-.21.41-.42.41L61.43,166.71a11.16,11.16,0,0,0,1,15.36,6.63,6.63,0,0,0,.79.8,7.46,7.46,0,0,0,.8.79,7.46,7.46,0,0,0,.79.8,7.46,7.46,0,0,0,.8.79,6.64,6.64,0,0,0,.79.8,7.55,7.55,0,0,0,.8.8,6.64,6.64,0,0,0,.8.79,6.63,6.63,0,0,0,.79.8,7.46,7.46,0,0,0,.8.79,11.22,11.22,0,0,0,1.63,1.51,10.23,10.23,0,0,0,7.1,2.5h57.82v7.92a11.4,11.4,0,0,0,3.73,8.57l0,0c.24.27.49.52.76.77,0,0,0,0,0,0,.25.27.51.53.78.77l0,0c.24.27.5.52.76.77l0,0c.25.27.51.53.78.77l0,0c.24.27.5.52.76.77l0,0a9.43,9.43,0,0,0,.78.77l0,0c.24.26.5.52.76.76l0,0a9.45,9.45,0,0,0,.77.78l0,0c.25.26.5.52.77.76l0,0a11.54,11.54,0,0,0,20-7.8V193.24h2.09a11.42,11.42,0,0,0,7.87-19.94Zm-40.88-44.72v33.75H109Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.06,173.3s0,0,0,0a9.81,9.81,0,0,0-.79-.79h0a9.57,9.57,0,0,0-.78-.78s0,0,0,0a8.41,8.41,0,0,0-.79-.79h0a8.41,8.41,0,0,0-.79-.79s0,0,0,0a9.57,9.57,0,0,0-.78-.78h0a9.81,9.81,0,0,0-.79-.79s0,0,0,0a9.57,9.57,0,0,0-.78-.78h0a9.81,9.81,0,0,0-.79-.79s0,0,0,0a9.57,9.57,0,0,0-.78-.78h0a11.41,11.41,0,0,0-2.79-2.24V85.29c0-.41-.21-.62-.21-1a2.24,2.24,0,0,0-.21-1.25c0-.21-.2-.63-.2-.84a8.57,8.57,0,0,0-.42-1.25,1.52,1.52,0,0,1-.42-.84,5.17,5.17,0,0,0-.84-1c-.21-.21-.41-.62-.62-.84l-.84-.83c0-.13-.16-.26-.34-.34l-.41-.42-.05,0c0-.13-.16-.25-.34-.34l-.41-.41,0,0c0-.13-.16-.26-.34-.34L161,75,161,75c0-.13-.16-.26-.34-.34l-.41-.41,0,0c0-.12-.16-.25-.34-.34l-.42-.41,0,0c0-.13-.16-.26-.34-.34l-.41-.42,0,0c0-.12-.16-.25-.34-.34l-.42-.41,0,0c0-.13-.16-.26-.34-.34L157,71,157,71c0-.13-.16-.25-.34-.34l-.41-.41,0,0c0-.13-.16-.26-.34-.34l-.46-.46c0-.2-.41-.41-.62-.41a.2.2,0,0,0-.2-.22c-.43-.2-.64-.41-1.06-.62-.21-.21-.62-.42-1-.84-.22,0-.63-.2-.84-.2-.42-.21-1-.21-1.25-.43a2,2,0,0,1-1.06-.2h-3.54a1.3,1.3,0,0,1-.84.2c-.62.22-1,.22-1.25.43-.41,0-.62.2-.84.62a2.27,2.27,0,0,0-1.25.42c-.2.21-.62.42-.84.62a2,2,0,0,1-1,.63,2.72,2.72,0,0,1-.62.84c-.21.21-.21.41-.42.41L61.43,166.71a11.16,11.16,0,0,0,1,15.36,6.63,6.63,0,0,0,.79.8,7.46,7.46,0,0,0,.8.79,7.46,7.46,0,0,0,.79.8,7.46,7.46,0,0,0,.8.79,6.64,6.64,0,0,0,.79.8,7.55,7.55,0,0,0,.8.8,6.64,6.64,0,0,0,.8.79,6.63,6.63,0,0,0,.79.8,7.46,7.46,0,0,0,.8.79,11.22,11.22,0,0,0,1.63,1.51,10.23,10.23,0,0,0,7.1,2.5h57.82v7.92a11.4,11.4,0,0,0,3.73,8.57l0,0c.24.27.49.52.76.77,0,0,0,0,0,0,.25.27.51.53.78.77l0,0c.24.27.5.52.76.77l0,0c.25.27.51.53.78.77l0,0c.24.27.5.52.76.77l0,0a9.43,9.43,0,0,0,.78.77l0,0c.24.26.5.52.76.76l0,0a9.45,9.45,0,0,0,.77.78l0,0c.25.26.5.52.77.76l0,0a11.54,11.54,0,0,0,20-7.8V193.24h2.09a11.42,11.42,0,0,0,7.87-19.94Zm-40.88-44.72v33.75H109Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.92,173.81a11.5,11.5,0,0,1-11.69,11.48h-2.09v15.87a11.48,11.48,0,0,1-23,0V185.29H70.4a10.24,10.24,0,0,1-7.1-2.51,11.17,11.17,0,0,1-1.88-16.07l77.26-96.06c.21,0,.21-.2.42-.41a2.9,2.9,0,0,0,.63-.84,2.26,2.26,0,0,0,1-.62c.21-.21.63-.42.83-.63a2.25,2.25,0,0,1,1.26-.42c.2-.42.41-.62.83-.62.21-.21.63-.21,1.26-.42a1.25,1.25,0,0,0,.83-.21h3.55a1.88,1.88,0,0,0,1,.21c.21.21.84.21,1.26.42.21,0,.62.2.83.2.42.42.84.63,1,.84.42.21.63.42,1.05.63a.21.21,0,0,1,.21.21c.21,0,.63.2.63.41l.83.84c.21.21.42.62.63.83a5.85,5.85,0,0,1,.83,1.05,1.57,1.57,0,0,0,.42.83,8.76,8.76,0,0,1,.42,1.26c0,.2.2.62.2.83a2.25,2.25,0,0,1,.21,1.25c0,.42.21.63.21,1v85h2.09A11.63,11.63,0,0,1,172.92,173.81Zm-36.74-63.06L94.62,162.32h41.56Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.07,97.61a59,59,0,0,0-8.17-9.94,3,3,0,0,0-.36-.35.57.57,0,0,0-.11-.11,4.11,4.11,0,0,0-.29-.3c-.27-.29-.55-.56-.83-.83l-.07-.07-.29-.28a.57.57,0,0,0-.11-.11l-.29-.31c-.27-.28-.56-.55-.83-.82a.18.18,0,0,0-.08-.07l-.28-.28a.57.57,0,0,0-.11-.11,2.91,2.91,0,0,0-.3-.31c-.26-.28-.55-.55-.82-.83l-.08-.06-.28-.29-.11-.1c-.1-.11-.19-.21-.3-.31-.26-.29-.55-.55-.82-.83l-.08-.06a2,2,0,0,0-.29-.29.94.94,0,0,0-.1-.1c-8.38-8.65-19.32-14.37-31.59-14.37-16.49,0-30.06,9.82-38.84,23.17-9.18,13.37-14,30.71-14.19,49.91.21,19,5,36.54,14.19,49.91a62,62,0,0,0,8.09,9.8l.41.4a.1.1,0,0,1,.05.06l.75.74c.12.14.25.26.38.39l.41.4.06.06.74.74.38.39c.14.14.28.27.41.41a.1.1,0,0,1,.06,0l.74.74c.13.14.25.27.38.39l.42.41a.12.12,0,0,1,.05.05l.74.74.38.39.42.41a.12.12,0,0,1,.05.05c.24.26.5.5.74.74,8.26,8.25,18.9,13.77,31.14,13.77,16.07,0,29.86-10,38.63-23.18,9-13.36,14-30.9,14-49.9C309.06,128.31,304.05,111,295.07,97.61ZM267.9,176.52c-6.06,9-12.94,12.95-19.42,12.95a19.16,19.16,0,0,1-11-3.79c-.29-.38-.58-.79-.87-1.2-5.84-8.77-10-22.13-10-37,0-15,4.18-28.19,10-37.17,6.27-8.77,13.37-12.94,19.84-12.74A17.43,17.43,0,0,1,266.92,101c.33.44.66.89,1,1.35,5.85,9,10,22.14,10,37.17C277.93,154.39,273.75,167.75,267.9,176.52Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.07,97.61a59,59,0,0,0-8.17-9.94,3,3,0,0,0-.36-.35.57.57,0,0,0-.11-.11,4.11,4.11,0,0,0-.29-.3c-.27-.29-.55-.56-.83-.83l-.07-.07-.29-.28a.57.57,0,0,0-.11-.11l-.29-.31c-.27-.28-.56-.55-.83-.82a.18.18,0,0,0-.08-.07l-.28-.28a.57.57,0,0,0-.11-.11,2.91,2.91,0,0,0-.3-.31c-.26-.28-.55-.55-.82-.83l-.08-.06-.28-.29-.11-.1c-.1-.11-.19-.21-.3-.31-.26-.29-.55-.55-.82-.83l-.08-.06a2,2,0,0,0-.29-.29.94.94,0,0,0-.1-.1c-8.38-8.65-19.32-14.37-31.59-14.37-16.49,0-30.06,9.82-38.84,23.17-9.18,13.37-14,30.71-14.19,49.91.21,19,5,36.54,14.19,49.91a62,62,0,0,0,8.09,9.8l.41.4a.1.1,0,0,1,.05.06l.75.74c.12.14.25.26.38.39l.41.4.06.06.74.74.38.39c.14.14.28.27.41.41a.1.1,0,0,1,.06,0l.74.74c.13.14.25.27.38.39l.42.41a.12.12,0,0,1,.05.05l.74.74.38.39.42.41a.12.12,0,0,1,.05.05c.24.26.5.5.74.74,8.26,8.25,18.9,13.77,31.14,13.77,16.07,0,29.86-10,38.63-23.18,9-13.36,14-30.9,14-49.9C309.06,128.31,304.05,111,295.07,97.61ZM267.9,176.52c-6.06,9-12.94,12.95-19.42,12.95a19.16,19.16,0,0,1-11-3.79c-.29-.38-.58-.79-.87-1.2-5.84-8.77-10-22.13-10-37,0-15,4.18-28.19,10-37.17,6.27-8.77,13.37-12.94,19.84-12.74A17.43,17.43,0,0,1,266.92,101c.33.44.66.89,1,1.35,5.85,9,10,22.14,10,37.17C277.93,154.39,273.75,167.75,267.9,176.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45,139.56c.21-19.21,5-36.54,14.2-49.9,8.76-13.37,22.34-23.18,38.83-23.18,16.08,0,29.86,9.81,38.64,23.18,9,13.36,14,30.69,14,49.9,0,19-5,36.54-14,49.91-8.78,13.15-22.56,23.17-38.64,23.17-16.49,0-30.07-10-38.83-23.17C200.46,176.1,195.66,158.56,195.45,139.56Zm82.47,0c0-15-4.17-28.19-10-37.17-6-8.77-12.94-12.94-19.42-12.73-6.47-.21-13.57,4-19.83,12.73-5.85,9-10,22.14-10,37.17,0,14.83,4.18,28.19,10,37,6.26,9,13.36,12.95,19.83,12.95s13.37-4,19.42-12.95C273.75,167.75,277.92,154.39,277.92,139.56Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.33,173.3s0,0,0,0c-.26-.28-.52-.54-.79-.79h0c-.25-.27-.52-.54-.78-.78,0,0,0,0,0,0-.26-.28-.52-.55-.79-.79h0c-.25-.28-.52-.54-.78-.79,0,0,0,0,0,0-.26-.27-.52-.54-.79-.78h0c-.26-.28-.52-.54-.79-.79,0,0,0,0,0,0-.25-.27-.52-.54-.78-.78h0c-.26-.28-.52-.54-.79-.79,0,0,0,0,0,0-.25-.27-.52-.54-.78-.78h0a11.23,11.23,0,0,0-2.8-2.24V85.29c0-.41-.21-.62-.21-1a2.24,2.24,0,0,0-.21-1.25c0-.21-.2-.63-.2-.84a8.57,8.57,0,0,0-.42-1.25,1.59,1.59,0,0,1-.42-.84,4.83,4.83,0,0,0-.84-1c-.21-.21-.41-.62-.62-.84l-.84-.83c0-.13-.16-.26-.34-.34l-.41-.42-.05,0c0-.13-.15-.25-.34-.34l-.41-.41,0,0c0-.13-.16-.26-.34-.34l-.41-.42-.05,0c0-.13-.16-.26-.34-.34l-.41-.41,0,0c0-.12-.16-.25-.34-.34l-.42-.41,0,0c0-.13-.16-.26-.34-.34l-.41-.42,0,0c0-.12-.16-.25-.34-.34l-.42-.41,0,0c0-.13-.16-.26-.34-.34l-.41-.42,0,0c0-.13-.15-.25-.34-.34l-.41-.41,0,0c0-.13-.16-.26-.34-.34l-.46-.46c0-.2-.41-.41-.62-.41a.22.22,0,0,0-.22-.22c-.41-.2-.62-.41-1-.62a13.22,13.22,0,0,1-1-.84c-.22,0-.63-.2-.84-.2-.42-.21-1-.21-1.25-.43a2,2,0,0,1-1.06-.2H406a1.3,1.3,0,0,1-.84.2c-.62.22-1,.22-1.25.43-.41,0-.62.2-.84.62a2.3,2.3,0,0,0-1.25.42c-.2.21-.62.42-.83.62a2.09,2.09,0,0,1-1,.63,2.89,2.89,0,0,1-.62.84c-.21.21-.21.41-.42.41l-77.25,96.06a11.16,11.16,0,0,0,1,15.36,268.15,268.15,0,0,1,2.38,2.39,7.46,7.46,0,0,0,.8.79,6.64,6.64,0,0,0,.79.8,7.55,7.55,0,0,0,.8.8,6.64,6.64,0,0,0,.8.79,89.39,89.39,0,0,0,1.59,1.59,11.22,11.22,0,0,0,1.63,1.51,10.23,10.23,0,0,0,7.1,2.5h57.82v7.92a11.42,11.42,0,0,0,3.73,8.57l0,0a9.45,9.45,0,0,0,.77.78l0,0c.25.26.5.52.77.76l0,0c.24.28.51.53.77.78l0,0c.25.26.5.52.77.76,0,0,0,0,0,0,.24.28.51.53.77.78l0,0c.25.27.5.52.77.76,0,0,0,0,0,0,.24.27.51.53.77.77l0,0c.24.27.49.52.76.77l0,0c.25.27.51.53.78.77l0,0a11.54,11.54,0,0,0,20-7.81V193.24h2.09a11.42,11.42,0,0,0,7.88-19.94Zm-40.89-44.72v33.75H369.25Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.33,173.3s0,0,0,0c-.26-.28-.52-.54-.79-.79h0c-.25-.27-.52-.54-.78-.78,0,0,0,0,0,0-.26-.28-.52-.55-.79-.79h0c-.25-.28-.52-.54-.78-.79,0,0,0,0,0,0-.26-.27-.52-.54-.79-.78h0c-.26-.28-.52-.54-.79-.79,0,0,0,0,0,0-.25-.27-.52-.54-.78-.78h0c-.26-.28-.52-.54-.79-.79,0,0,0,0,0,0-.25-.27-.52-.54-.78-.78h0a11.23,11.23,0,0,0-2.8-2.24V85.29c0-.41-.21-.62-.21-1a2.24,2.24,0,0,0-.21-1.25c0-.21-.2-.63-.2-.84a8.57,8.57,0,0,0-.42-1.25,1.59,1.59,0,0,1-.42-.84,4.83,4.83,0,0,0-.84-1c-.21-.21-.41-.62-.62-.84l-.84-.83c0-.13-.16-.26-.34-.34l-.41-.42-.05,0c0-.13-.15-.25-.34-.34l-.41-.41,0,0c0-.13-.16-.26-.34-.34l-.41-.42-.05,0c0-.13-.16-.26-.34-.34l-.41-.41,0,0c0-.12-.16-.25-.34-.34l-.42-.41,0,0c0-.13-.16-.26-.34-.34l-.41-.42,0,0c0-.12-.16-.25-.34-.34l-.42-.41,0,0c0-.13-.16-.26-.34-.34l-.41-.42,0,0c0-.13-.15-.25-.34-.34l-.41-.41,0,0c0-.13-.16-.26-.34-.34l-.46-.46c0-.2-.41-.41-.62-.41a.22.22,0,0,0-.22-.22c-.41-.2-.62-.41-1-.62a13.22,13.22,0,0,1-1-.84c-.22,0-.63-.2-.84-.2-.42-.21-1-.21-1.25-.43a2,2,0,0,1-1.06-.2H406a1.3,1.3,0,0,1-.84.2c-.62.22-1,.22-1.25.43-.41,0-.62.2-.84.62a2.3,2.3,0,0,0-1.25.42c-.2.21-.62.42-.83.62a2.09,2.09,0,0,1-1,.63,2.89,2.89,0,0,1-.62.84c-.21.21-.21.41-.42.41l-77.25,96.06a11.16,11.16,0,0,0,1,15.36,268.15,268.15,0,0,1,2.38,2.39,7.46,7.46,0,0,0,.8.79,6.64,6.64,0,0,0,.79.8,7.55,7.55,0,0,0,.8.8,6.64,6.64,0,0,0,.8.79,89.39,89.39,0,0,0,1.59,1.59,11.22,11.22,0,0,0,1.63,1.51,10.23,10.23,0,0,0,7.1,2.5h57.82v7.92a11.42,11.42,0,0,0,3.73,8.57l0,0a9.45,9.45,0,0,0,.77.78l0,0c.25.26.5.52.77.76l0,0c.24.28.51.53.77.78l0,0c.25.26.5.52.77.76,0,0,0,0,0,0,.24.28.51.53.77.78l0,0c.25.27.5.52.77.76,0,0,0,0,0,0,.24.27.51.53.77.77l0,0c.24.27.49.52.76.77l0,0c.25.27.51.53.78.77l0,0a11.54,11.54,0,0,0,20-7.81V193.24h2.09a11.42,11.42,0,0,0,7.88-19.94Zm-40.89-44.72v33.75H369.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.19,173.81a11.5,11.5,0,0,1-11.7,11.48H419.4v15.87a11.48,11.48,0,1,1-23,0V185.29H330.66a10.24,10.24,0,0,1-7.1-2.51,11.17,11.17,0,0,1-1.88-16.07l77.26-96.06c.21,0,.21-.2.42-.41a2.9,2.9,0,0,0,.63-.84,2.26,2.26,0,0,0,1-.62c.21-.21.63-.42.84-.63a2.19,2.19,0,0,1,1.25-.42c.2-.42.41-.62.83-.62.21-.21.63-.21,1.26-.42a1.25,1.25,0,0,0,.83-.21h3.55a1.88,1.88,0,0,0,1,.21c.21.21.84.21,1.26.42.21,0,.63.2.83.2.42.42.84.63,1,.84.42.21.63.42,1.05.63A.21.21,0,0,1,415,69c.21,0,.63.2.63.41l.83.84c.21.21.42.62.63.83a5.42,5.42,0,0,1,.83,1.05,1.57,1.57,0,0,0,.42.83,8.76,8.76,0,0,1,.42,1.26c0,.2.2.62.2.83a2.25,2.25,0,0,1,.21,1.25c0,.42.21.63.21,1v85h2.09A11.63,11.63,0,0,1,433.19,173.81Zm-36.75-63.06-41.56,51.57h41.56Z",
    style: {
      fill: "#F0934E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bonfire--inject-52"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256.63,
    cy: 379.49,
    r: 10.63,
    style: {
      fill: "#F0934E",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.63,
    cy: 381.91,
    r: 8.16,
    style: {
      fill: "#F0934E",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.36,390.05s-6.49-.95-6.87-.7-.75,2.14,0,2.6,6.72-.37,6.72-.37A1.2,1.2,0,0,0,257.36,390.05Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.36,390.05s-6.49-.95-6.87-.7-.75,2.14,0,2.6,6.72-.37,6.72-.37A1.2,1.2,0,0,0,257.36,390.05Z",
    style: {
      opacity: 0.49
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.52,389.43c.19-.05.51.6.44,1.32s-.33,1.15-.44,1.14-.47-.42-.41-1.31C250.16,389.94,250.35,389.46,250.52,389.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.2,389.61a8.35,8.35,0,0,1,1.12,0l.56.05.28.05a1.31,1.31,0,0,0,.27.06,9.82,9.82,0,0,0,1.09.12l1.12.1a10.57,10.57,0,0,1-1.12,0,7.16,7.16,0,0,1-1.13-.08,1.19,1.19,0,0,1-.27-.07l-.27-.05-.54-.08Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.93,390l.79.13c.26.05.52.11.77.14a6.74,6.74,0,0,0,.78,0l.79,0a6.74,6.74,0,0,1-.78.16,3.62,3.62,0,0,1-.81,0,6.34,6.34,0,0,1-.78-.18A5.29,5.29,0,0,1,251.93,390Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255.12,390.56a2.22,2.22,0,0,1,1.17-.43,1.38,1.38,0,0,1,.63.11.77.77,0,0,1,.29.19.49.49,0,0,1,.1.16.15.15,0,0,1,0,.07.11.11,0,0,1,0,0s0,0,0,0a.28.28,0,0,1-.06.08,1.06,1.06,0,0,1-.59.31.66.66,0,0,1-.34,0L256,391c-.09-.07-.19-.12-.24-.25a.13.13,0,0,1,0-.12.13.13,0,0,1,.08-.07l.16,0a1.13,1.13,0,0,1,.32,0,.59.59,0,0,1,.29.1.92.92,0,0,0-.59,0l-.14,0s0,0,0,.06.12.12.2.16a1.53,1.53,0,0,0,.27.11.5.5,0,0,0,.27,0,1,1,0,0,0,.49-.27l0,0h0a.35.35,0,0,0-.06-.09.63.63,0,0,0-.23-.16,1.52,1.52,0,0,0-.56-.12,2.06,2.06,0,0,0-.6.08A3.28,3.28,0,0,0,255.12,390.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.28,391.19a2.48,2.48,0,0,1-.81.26,2.06,2.06,0,0,1-.43,0,2.09,2.09,0,0,1-.43-.11,4.75,4.75,0,0,1-.75-.37,3,3,0,0,0-.78-.27,1.7,1.7,0,0,1,.83.15c.27.1.51.23.76.32a2,2,0,0,0,.79.13A4,4,0,0,0,257.28,391.19Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M251,391.74h1a8,8,0,0,0,1,0,4.26,4.26,0,0,1,1-.06c.33,0,.66.06,1,.11l-1,0a6.25,6.25,0,0,0-1,.09,4.35,4.35,0,0,1-1,0A8.46,8.46,0,0,1,251,391.74Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M255.46,391.53l-.83-.2-.42-.08a1.08,1.08,0,0,0-.4,0l-.84.17-.43.05a1.39,1.39,0,0,1-.45,0,3.31,3.31,0,0,1-.42-.12,1.12,1.12,0,0,1-.4-.24.52.52,0,0,1-.06-.13.22.22,0,0,1,0-.16.35.35,0,0,1,.21-.16,1.36,1.36,0,0,1,.44-.08,3.24,3.24,0,0,1,.44,0,1,1,0,0,1,.42.15.16.16,0,0,1,.08.11c0,.07-.07.09-.1.11l-.21,0a2.08,2.08,0,0,1-.43,0l.42-.05c.12,0,.34-.09.19-.15a.84.84,0,0,0-.39-.1,1.87,1.87,0,0,0-.41,0,1.67,1.67,0,0,0-.4.08c-.05,0-.1.06-.11.09a.09.09,0,0,0,0,.11.88.88,0,0,0,.33.18,3,3,0,0,0,.4.12,2.86,2.86,0,0,0,.82,0c.28,0,.55-.1.84-.13l.22,0a1.46,1.46,0,0,1,.22,0l.42.11C254.92,391.33,255.19,391.42,255.46,391.53Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.63,390.73c-.39-.07-.75-.17-1.12-.27l-.54-.14a2.13,2.13,0,0,0-.56-.1,1.27,1.27,0,0,1,.58,0,3.59,3.59,0,0,1,.57.11A4.73,4.73,0,0,1,253.63,390.73Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M256.46,390s6.5-.88,6.89-.62.71,2.15-.07,2.6-6.73-.45-6.73-.45A1.2,1.2,0,0,1,256.46,390Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.46,390s6.5-.88,6.89-.62.71,2.15-.07,2.6-6.73-.45-6.73-.45A1.2,1.2,0,0,1,256.46,390Z",
    style: {
      opacity: 0.49
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.31,389.46c-.19,0-.52.6-.45,1.32s.31,1.15.42,1.14.47-.41.42-1.3C263.67,390,263.48,389.5,263.31,389.46Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256.7,391.35l1.11.06a5.09,5.09,0,0,0,.55,0h.27l.29,0a7,7,0,0,1,1.12.11,10,10,0,0,1,1.09.23l-1.11-.09c-.37,0-.74-.07-1.1-.07l-.27,0a1.41,1.41,0,0,1-.29,0,5.09,5.09,0,0,1-.56,0C257.43,391.5,257.06,391.43,256.7,391.35Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M257.37,391.33a5.51,5.51,0,0,1,.77-.21,5.32,5.32,0,0,1,.8-.12,3.5,3.5,0,0,1,.8.09,6.77,6.77,0,0,1,.77.22l-.79-.08a6.78,6.78,0,0,0-.77-.05l-.78.08Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M260.59,391a4,4,0,0,0,.56.26,2.38,2.38,0,0,0,.59.12,1.36,1.36,0,0,0,.57-.08.58.58,0,0,0,.24-.14.2.2,0,0,0,.07-.09h0l0-.05a1,1,0,0,0-.47-.3.57.57,0,0,0-.26,0l-.29.08a.49.49,0,0,0-.21.15s0,0,0,.06l.13,0a.88.88,0,0,0,.6,0,.55.55,0,0,1-.3.09,1.15,1.15,0,0,1-.32,0l-.16-.05s-.06,0-.08-.08a.11.11,0,0,1,0-.11.5.5,0,0,1,.26-.24l.3-.11a.69.69,0,0,1,.35,0,1.14,1.14,0,0,1,.56.35l0,.09s0,0,0,0,0,0,0,0a.12.12,0,0,1,0,.07.45.45,0,0,1-.11.15.83.83,0,0,1-.3.17,1.4,1.4,0,0,1-.64.06A2.34,2.34,0,0,1,260.59,391Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M262.79,390.51a3.7,3.7,0,0,0-.8-.18,1.92,1.92,0,0,0-.79.06c-.26.07-.51.18-.79.27a1.84,1.84,0,0,1-.84.08,2.7,2.7,0,0,0,.8-.21,4.88,4.88,0,0,1,.78-.31,1.55,1.55,0,0,1,.43-.07,2,2,0,0,1,.43,0A2.34,2.34,0,0,1,262.79,390.51Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258.91,389.89a8.46,8.46,0,0,1,1-.15,4.35,4.35,0,0,1,1,0,6.26,6.26,0,0,0,1,.09l1,0a8.52,8.52,0,0,1-1,.12,4.28,4.28,0,0,1-1,0,6.34,6.34,0,0,0-1,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M261,390l-.83.22-.42.07a.89.89,0,0,1-.23,0l-.22,0-.83-.2a2.84,2.84,0,0,0-.81-.09l-.4.08a1,1,0,0,0-.35.16.12.12,0,0,0,0,.11.21.21,0,0,0,.11.09,1.61,1.61,0,0,0,.39.12,2.73,2.73,0,0,0,.41,0,.85.85,0,0,0,.39-.07c.15,0-.06-.12-.18-.16a2.71,2.71,0,0,0-.41-.09l.42,0a.94.94,0,0,1,.22.07.11.11,0,0,1,.08.11.16.16,0,0,1-.08.11,1.14,1.14,0,0,1-.44.11,2.07,2.07,0,0,1-.43,0,1.4,1.4,0,0,1-.44-.1.4.4,0,0,1-.2-.19.26.26,0,0,1,0-.15.33.33,0,0,1,.07-.13,1.11,1.11,0,0,1,.42-.21,3,3,0,0,1,.43-.09,1.68,1.68,0,0,1,.45,0,3.15,3.15,0,0,1,.42.09l.82.23a1.12,1.12,0,0,0,.41,0l.42,0C260.45,390.13,260.73,390.08,261,390Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M259.12,390.69a4.7,4.7,0,0,1-1.1.35,5.54,5.54,0,0,1-.57.07,1.29,1.29,0,0,1-.58-.09,2.54,2.54,0,0,0,.56,0l.56-.11A10.24,10.24,0,0,1,259.12,390.69Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M260.85,391.39c.3.1.57.19.86.26l.43.08.45,0a1.15,1.15,0,0,1-.45.11,1.83,1.83,0,0,1-.47-.05,2.32,2.32,0,0,1-.44-.16A1.46,1.46,0,0,1,260.85,391.39Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M261.87,376.25a.2.2,0,0,0,.21.2.2.2,0,0,0,.2-.2.2.2,0,0,0-.2-.21A.21.21,0,0,0,261.87,376.25Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.72,367.6a.2.2,0,1,0,.2-.2A.2.2,0,0,0,259.72,367.6Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,374.93a.2.2,0,0,0,.28,0,.21.21,0,0,0,0-.29.2.2,0,0,0-.28,0A.19.19,0,0,0,252,374.93Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22,387.23a.2.2,0,1,0,.4,0,.2.2,0,1,0-.4,0Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.8,385.86a.2.2,0,1,0,.2-.2A.2.2,0,0,0,262.8,385.86Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.6,377.56a.27.27,0,0,0,.27.27.27.27,0,1,0,0-.54A.27.27,0,0,0,261.6,377.56Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.12,372.68a.27.27,0,1,0-.05-.39A.27.27,0,0,0,253.12,372.68Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.73,382.76a.28.28,0,0,0,.28.27.27.27,0,0,0,.27-.27.28.28,0,0,0-.27-.28A.29.29,0,0,0,250.73,382.76Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.17,377.17a.12.12,0,0,0,.12.12.12.12,0,0,0,.12-.12.13.13,0,0,0-.12-.12A.12.12,0,0,0,261.17,377.17Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.29,
    cy: 380.99,
    r: 0.12,
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.71,384.78a.12.12,0,0,0,.12.12.12.12,0,0,0,.12-.12.12.12,0,0,0-.12-.12A.13.13,0,0,0,263.71,384.78Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.34,381.91a.12.12,0,0,0,.12.12.12.12,0,0,0,.12-.12.13.13,0,0,0-.12-.12A.12.12,0,0,0,250.34,381.91Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.77,373.44a.11.11,0,0,0,.11.11.11.11,0,0,0,.12-.11.12.12,0,0,0-.12-.12A.11.11,0,0,0,262.77,373.44Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.45,
    cy: 372.34,
    r: 0.12,
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.56,
    cy: 370.56,
    r: 0.12,
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.5,390.33a15.57,15.57,0,0,0,3.86.93h.79s2-.47,2.27-.57,1,.21,1.28,0a8.92,8.92,0,0,0,1.91-2,10.28,10.28,0,0,0-.52-2.12c0-.29.4-2,.44-2.58s-1.65-3.39-1.81-3.85a6.31,6.31,0,0,1,.49-2.13s-1.39,1.46-1.35,1.81.68,1.13.72,1.38-.87,2-.84,2.26a6.63,6.63,0,0,1,.4,1.42,2.14,2.14,0,0,0-.64-1.1,12,12,0,0,1-1.05-.65,5.35,5.35,0,0,1-.65-1.78,2.35,2.35,0,0,0,.38-1.21,12.84,12.84,0,0,0-1.31-2.62s.22,1.12,0,1.39-1,.68-1.09.89.72,1.12.62,1.34-1.89.59-2.07.84a6.24,6.24,0,0,0-.54,2.48c.13.36.56,1.73.32,2s-.78.38-.8.27a4.6,4.6,0,0,0,.19-1.5c-.13-.53-.7-1.69-.74-2a8.27,8.27,0,0,1,.51-2.06,11,11,0,0,0-1.17,2.33,21.77,21.77,0,0,0,.31,2.39s-.26-.17-.32-.29a6,6,0,0,1,0-1,5,5,0,0,0-.8,1.21c-.08.36.33,1.26.27,1.57s-.38,1-.42,1.4S252.19,390.14,252.5,390.33Zm8.58-2.71a4.13,4.13,0,0,1-.47,1.21s.09-.59.09-.83a4.16,4.16,0,0,0-.26-.91,1.56,1.56,0,0,1,.3-1.07A6.16,6.16,0,0,1,261.08,387.62Zm-1.68,2.78.73-.64c.24-.22.95-.54,1.08-.75a8.11,8.11,0,0,0,.34-1.25,5.53,5.53,0,0,1,.09,1.38,3.76,3.76,0,0,1-1.17,1.21A2.92,2.92,0,0,1,259.4,390.4Zm-5.29-3.15a3.47,3.47,0,0,0-.41,1.08,2,2,0,0,0,.34,1,4.4,4.4,0,0,1,.31.84s-.84-.39-1-1S254.06,387.32,254.11,387.25Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.8,378.41s.87-.62.89-1.08-.54-1.45-.48-1.82a2.74,2.74,0,0,1,.25-.74s-.92.63-.92,1.15.55,1.34.5,1.6S259.8,378.41,259.8,378.41Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.6,381.26a3.26,3.26,0,0,0,.17-.86,1.35,1.35,0,0,0-.32-.57.68.68,0,0,0-.11.64C254.45,380.87,254.6,381.26,254.6,381.26Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.45,381.15a3.52,3.52,0,0,0,.5-1.32,3.3,3.3,0,0,0-.36-1.54,2,2,0,0,0-.57-.46,2.37,2.37,0,0,1,.32.72c0,.22-.16.91-.18,1.18A9.35,9.35,0,0,0,252.45,381.15Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.1,377.56s.65-.89.53-1.47a3.87,3.87,0,0,0-.83-1.52,8.56,8.56,0,0,1-.87-1,2.54,2.54,0,0,1,0-1.74,1.74,1.74,0,0,1,.57-.45,1.79,1.79,0,0,0-1.46.75c-.57.79-1.3,3.88-1,4.59a4.85,4.85,0,0,0,1.3,1.39,6.82,6.82,0,0,1-.17-1.53c.09-.3,1,0,1.22.19A6.12,6.12,0,0,1,258.1,377.56Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.6,381.93s.4-.42.32-.78-.6-.9-.63-1.07a4.64,4.64,0,0,1,.12-.86s-.52,1-.4,1.28.22.76.22.76-.23-.15-.28-.28a2.16,2.16,0,0,1-.09-.33s-.39.49-.27.83a4.33,4.33,0,0,0,.8,1,2.2,2.2,0,0,1,0-.31C259.39,382.05,259.46,382.11,259.6,381.93Z",
    style: {
      fill: "#F0934E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.82,391.26s2.37-.86,2.9-2.07c.33-.76-.56-2.32-.64-2.56s0-1.2-.1-1.58-1.8-1.37-2-1.63.29-1.3.29-1.3-1.27,1-1.46,1.61.56,1.72.56,1.93a3.2,3.2,0,0,1-.45.83,1.71,1.71,0,0,1-.35-.83c0-.4.19-.6.15-.88a2.65,2.65,0,0,0-.56-.81,1.17,1.17,0,0,1,.14.81c-.14.33-.78,1-.69,1.49s.86,1.69.79,2a1.59,1.59,0,0,1-.24.55,4.81,4.81,0,0,1-.27-.8c-.07-.32-.14-.75-.14-.75s-.39,2.11,0,2.7A6.47,6.47,0,0,0,256.82,391.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.45,376.59a3.05,3.05,0,0,0,.28-.92c0-.31-.55-.73-.81-1a2.46,2.46,0,0,1-.76-1.4c0-.4.11-.7.11-.7a13.71,13.71,0,0,0-.74,3,2,2,0,0,0,.46,1.17s.15-.68.48-.66A2.09,2.09,0,0,1,257.45,376.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,378.1s.51-.47.5-.79a4.52,4.52,0,0,0-.5-1.19s.22,1,.25,1.23A2,2,0,0,1,260,378.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.15,390.51s-1-.64-1.22-.8a3.15,3.15,0,0,1-.45-1.26c0-.18.35-1,.35-1.2s-.67-1-.67-1a4,4,0,0,1,.18.93c0,.18-.92,1.22-.86,1.61s.89,1.09,1.13,1.25A10.5,10.5,0,0,0,254.15,390.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.41,386.37a9.67,9.67,0,0,0,.62-2.24,18.24,18.24,0,0,0-.86-2.24s.06,1.51.12,1.75a3.06,3.06,0,0,1-.12,1,7.4,7.4,0,0,1-.29-.71A4.16,4.16,0,0,1,261,383a5,5,0,0,0-.38,1.81A8.38,8.38,0,0,0,261.41,386.37Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.2403c9c4654ab3b3e8c5175a17198352.svg";
export { ForwardRef as ReactComponent };